module.exports = __webpack_public_path__ + "static/media/downArrowIconDark.4a3714d6.svg";